import {Booster} from '@/app/core/models/collection/booster';

const BOOSTER_IMAGES_PATH = 'assets/images/booster';

/** Image par défaut quand l'extension du booster est inconnue (ex: récompense de palier BattlePeps). */
export const DEFAULT_BOOSTER_IMAGE = `${BOOSTER_IMAGES_PATH}/booster_extension_0.png`;

/** Boosters « spéciaux » : image dédiée selon un fragment du nom (insensible à la casse). */
const SPECIAL_BOOSTER_IMAGES: { match: string; src: string }[] = [
	{ match: 'zevent', src: `${BOOSTER_IMAGES_PATH}/booster_zevent.png` },
];

/** Image du booster : spéciale (par nom), sinon selon son extension (id « extension-N » → booster_extension_N.png), sinon null. */
export function boosterImageOrNull(booster: Pick<Booster, 'name' | 'extension'>): string | null {
	const name = (booster.name ?? '').toLowerCase();
	const special = SPECIAL_BOOSTER_IMAGES.find(b => name.includes(b.match));
	if (special) return special.src;
	const index = /^extension-(\d+)$/.exec(booster.extension?.id ?? '')?.[1];
	return index ? `${BOOSTER_IMAGES_PATH}/booster_extension_${index}.png` : null;
}

/** Comme {@link boosterImageOrNull} mais avec l'image par défaut en repli. */
export function boosterImage(booster: Pick<Booster, 'name' | 'extension'>): string {
	return boosterImageOrNull(booster) ?? DEFAULT_BOOSTER_IMAGE;
}
